export default __webpack_public_path__ + "static/media/peepslogo.b210cc7a.png";